import { createRoot } from 'react-dom/client';
import 'react-h5-audio-player/lib/styles.css';
import 'uplot/dist/uPlot.min.css';
import './index.css';
import AppComponent from './AppComponent';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<AppComponent />);
